import { enGB, es, fr, nl, pt, it, de, pl, ro, el } from "date-fns/locale";
import { languageNames } from "../../../periodic-reviews-webapp/src/constants.ts";

export const getDatePickerLocale = (lang: keyof typeof languageNames) => {
  // defaults
  const locale = {
    en: enGB,
    es,
    fr,
    nl,
    pt,
    it,
    de, 
    pl, 
    ro, 
    gr: el, 
  };
  //TODO: add new language here
  return locale[lang as keyof typeof locale] || "";
};
